import { combineReducers } from 'redux'

import { exchangeSettingsProfile } from './exchangeSettings'
import { partnersProfile } from './partners'
import { exchangeFeedbackProfile } from './exchangeFeedback'
import { exchangeConfigProfile } from './exchangeConfig'

export const exchangeReducer = combineReducers({
  exchangeSettingsProfile,
  partnersProfile,
  exchangeFeedbackProfile,
  exchangeConfigProfile
})
